import { render, staticRenderFns } from "./DailyHoroscope.vue?vue&type=template&id=7426b134&scoped=true&"
import script from "./DailyHoroscope.vue?vue&type=script&lang=js&"
export * from "./DailyHoroscope.vue?vue&type=script&lang=js&"
import style0 from "./DailyHoroscope.vue?vue&type=style&index=0&id=7426b134&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7426b134",
  null
  
)

export default component.exports